import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { BrandDirectivesModule } from '@amfam/shared/utility/brand';
import { SharedServicesModule } from '@amfam/shared/utility/shared-services';
import { UiKitModule } from '@amfam/ui-kit';

// store
import { AppStateEffects } from './+state/app-state/app-state.effects';
import { GeoCoderEffects } from './+state/geo-coder/geo-coder.effects';
import * as reducers from './+state/selectors';
import { ServiceLocatorEffects } from './+state/service-locator/service-locator.effects';
// Components
import { AutofillDropdownComponent } from './components/autofill-dropdown/autofill-dropdown.component';
import { ClickOutsideDirective } from './components/autofill-dropdown/click-outside.directive';
import { LoadingSpinnerComponent } from './components/loading-spinner/loading-spinner.component';
import { ModalComponent } from './components/modal/modal.component';
import { NoResultsCardComponent } from './components/no-results-card/no-results-card.component';
import { ResultsMapComponent } from './components/results-map/results-map.component';
import { ResultsWrapperComponent } from './components/results-wrapper/results-wrapper.component';
import { SearchByAutocompleteFormComponent } from './components/search-by-autocomplete-form/search-by-autocomplete-form.component';
import { SearchByLocationFormComponent } from './components/search-by-location-form/search-by-location-form.component';
import { SearchByNameFormComponent } from './components/search-by-name-form/search-by-name-form.component';
import { SearchWrapperComponent } from './components/search-wrapper/search-wrapper.component';
import { ShopCardHoursComponent } from './components/shop-card-hours/shop-card-hours.component';
import { ShopCardComponent } from './components/shop-card/shop-card.component';
import { DrpSearchComponent } from './containers/drp-search/drp-search.component';

const appEffects = [AppStateEffects, ServiceLocatorEffects, GeoCoderEffects];

@NgModule({
  declarations: [
    AutofillDropdownComponent,
    ClickOutsideDirective,
    DrpSearchComponent,
    ModalComponent,
    NoResultsCardComponent,
    ResultsMapComponent,
    ResultsWrapperComponent,
    SearchByAutocompleteFormComponent,
    SearchByLocationFormComponent,
    SearchByNameFormComponent,
    ShopCardComponent,
    ShopCardHoursComponent,
    SearchWrapperComponent,
    LoadingSpinnerComponent
  ],
  exports: [DrpSearchComponent, ModalComponent],
  imports: [
    StoreModule.forFeature('drpSearch', reducers.reducers),
    EffectsModule.forFeature(appEffects),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UiKitModule,
    BrandDirectivesModule,
    SharedServicesModule
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class ClaimDrpSearchFeatureModule {}
